export default class Helper {

    /**
     * Создаёт чистую копию объекта
     * @param source Object
     * @returns {Object}
     */
    static copyObject(source)
    {
        return JSON.parse(JSON.stringify(source));
    }

    /**
     * Возвращает необходимую форму слова из массива forms в зависимости от count
     * @param count Number количество
     * @param forms Array массив форм вида ['товар', 'товара', 'товаров']
     * @returns {String} форма слова из forms
     */
    static pluralForm (count, forms) {
        return count % 10 === 1 && count % 100 !== 11 ? forms[0] : (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20) ? forms[1] : forms[2]);
    }

}